<template>
  <div class="content">
    <div class="condition">
      <div class="search_wrap">
        <el-form :inline="true" class="form-inline">
          <!--<el-form-item>-->
          <!--<span class="choosedep">{{formdata.depart_name}}</span>-->
          <!--<el-button @click="choosedep" size="small">选择部门</el-button>-->
          <!--</el-form-item>-->
          <!--<el-form-item>-->
          <!--<el-radio-group v-model="params.type" size="small" @change="typeFn">-->
          <!--<el-radio-button label="0">优惠券</el-radio-button>-->
          <!--<el-radio-button label="1">进行中</el-radio-button>-->
          <!--<el-radio-button label="2">未开始</el-radio-button>-->
          <!--<el-radio-button label="3">已结束</el-radio-button>-->
          <!--</el-radio-group>-->
          <!--</el-form-item>-->
          <el-form-item>
            <el-input v-model="searchName" placeholder="输入姓名搜索" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search" size="small"></el-button>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="edit('add')">添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table_wrap">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="coupon_type" label="类型"></el-table-column>
        <el-table-column prop="desc" label="面值">
        </el-table-column>
        <el-table-column prop="limit" label="领取限制">
        </el-table-column>
        <el-table-column prop="used" label="已领取/已使用" width="100">
        </el-table-column>
        <el-table-column prop="type" label="适用商品"></el-table-column>
        <el-table-column prop="get_time" label="有效期"></el-table-column>
        <!--<el-table-column prop="use_time" label="使用时间" width="180"></el-table-column>-->
        <el-table-column prop="create_time" label="添加时间" width="100"></el-table-column>
        <el-table-column prop="status" label="状态" width="70"></el-table-column>
        <el-table-column prop="online_offline" label="员工派发" width="70"></el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit('edit',scope.$index)">编辑</el-button>
            <el-button type="text" size="small" @click="detelFn(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag_wrap">
        <el-pagination
                background
                @current-change="pageIndexChange"
                :page-size="page.pagesize"
                :current-page="page.pageindex"
                layout="total, prev, pager, next"
                :total="page.total"
        ></el-pagination>
      </div>
    </div>
    <chooseDepDialog
            :visible.sync="choosedepdialog"
            v-if="choosedepdialog"
            @choosedepsucess="choosedepsucess"
    ></chooseDepDialog>
  </div>
</template>
<script>
  import chooseDepDialog from "@/components/dialog/chooseDepDialog.vue";
  import api from "@/api.js";
  import {pagination} from "@/util/util.js";

  export default {
    name: "privilegeCoupon",
    components: {
      chooseDepDialog
    },
    data() {
      return {
        searchName:'',
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        tableData: [],
        multipleSelection: [],
        choosedepdialog: false
      };
    },
    created() {
      this.search();
    },
    methods: {
      search() {
        this.axios
            .post(api.discount_coupon, {page:this.page.pageindex,name:this.searchName})
            .then(response => {
              if (response.data.code == 0) {
                this.tableData = response.data.list
                this.page.total = response.data.all_page
              } 
            })
            .catch(response => {
            });
      },
      // 分页
      pageIndexChange(pageindex) {
        this.page.pageindex = pageindex;
        this.search();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      edit(type,index) {
        let query = {}
        if(type==='edit'){
          query.id=this.tableData[index].id
        }
        this.$router.push({name: "privilegeCouponEdit", query: query});
      },
      detelFn(index){
        let that_ = this
        let obj_ = {
          cate : 3,
          cb_id: this.tableData[index].id
        }
        this.$confirm('此操作将永久删除该优惠卷, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that_.axios
              .post(api.discount_coupon_couponBag, obj_)
              .then(response => {
                if (response.data.code == 0) {
                  that_.tableData.splice(index,1)
                  that_.$message({
                    message: '删除成功!'
                  });
                } 
              })
              .catch(response => {
              });

        }).catch(() => {
        });


      }
    }
  };
</script>
